import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { CTAButton } from 'shared-components/buttons/cta-button';
import AddtlTaxFeesFormContainer from '../../app-main/components/reduxForms/forms/AddtlTaxFeesForm/AddtlTaxFeesFormContainer';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

class AddtlTaxFeesModal extends React.Component {
  render () {
    const { addAddtlTaxorFee, currency, toggleModal } = this.props;
    return (
      <BootstrapModal
        {...this.props}
        modalSize="lg-size"
        modalClass="addtl-tax-fees-modal"
        header={
          <div>
            <h3>
              <FormattedMessage
                id="inbox.addtl_tax_fees_modal.add_tax"
                defaultMessage="Add additional tax or fees"
              />
            </h3>
            <p>
              <FormattedMessage
                id="inbox.addtl_tax_fees_modal.tax_applied"
                defaultMessage="Additional tax or fees will be applied to the total amount of add-ons."
              />
            </p>
          </div>
        }
        body={
          <AddtlTaxFeesFormContainer
            currency={currency}
            toggleModal={toggleModal}
          />
        }
        footer={
          <div>
            <hr />
            <CTAButton
              buttonText={ this.props.intl.formatMessage({ id: 'inbox.addtl_tax_fees_modal.add', defaultMessage: 'Add' }) }
              classNameString="btn btn-primary form"
              onClickAction={addAddtlTaxorFee}
              isDisabled={ false }
              attributes={{ 'data-testing-id': 'add-tax-fees-btn' }}
            />
          </div>
        }
      />
    );
  }
}

AddtlTaxFeesModal.propTypes = {
  errorMsg: PropTypes.string,
  toggleModal: PropTypes.func,
  currency: PropTypes.string,
  addAddtlTaxorFee: PropTypes.func,
  intl: intlShape
};

exports.AddtlTaxFeesModal = injectIntl(AddtlTaxFeesModal);
